export const notchHeight = 8;
export const notchWidth = 26;
export const borderRadius = 16;
